export default __webpack_public_path__ + "static/media/disciplina.1c2a9136.png";